<template>
    <div class="dropdown"
         ref="languageDropDown" v-closable="{handler: 'closeMenu',exclude:['languageDropDown']}"
         v-if="challengeGroupTechnologies.length > 6" @click="clickHandler">
        <span class="dropdown-label" for="dropdownMenuButton">Programmiersprache:</span>
        <button class="btn btn-secondary dropdown-toggle"
                :class="getLanguageBubbleCSS(selectedTechnology)" type="button" id="dropdownMenuButton">
                            <span class="dropdown-text">{{
                                    getTechnologyDisplayNameShort(selectedTechnology).toUpperCase()
                                }}</span>
            <i class="fa fa-caret-down dropdown-icon"></i>
        </button>
        <div class="dropdown-menu scale-in-ver-top" v-if="dropDownOpen" aria-labelledby="dropdownMenuButton">
            <div v-for="(technology, index) in challengeGroupTechnologies">
                <input @input="handleInput" :value="technology.challengeId" type="radio"
                       :id="'radio'+ index+1" name="tabs"/>
                <label class="tab dropdown-menu-item" :for="'radio'+ index+1"
                       :class="getActiveClass(technology)">
                    <i class="challenge-state-icon" :class="{'dev-check': technology.isSolved}"></i>
                    <span class="dropdown-menu-item-text">{{
                            getTechnologyDisplayNameShort(technology).toUpperCase()
                        }}</span>
                </label>
            </div>
        </div>
    </div>
</template>
<script>
import {getLanguageBubbleCSS} from "../../services/Utilities";
import {LANGUAGES} from "../../const";
import "../../directives/closeable";

export default {
    name: "LanguageDropDown",
    props: {
        challengeGroupTechnologies: {type: Array, default: () => []},
        value: {type: String, default: ""},
    },
    data: function () {
        return {
            selectedChallengeId: this.value,
            dropDownOpen: false,
        }
    },
    computed: {
        selectedTechnology: function () {
            let challengeGroupTechnology = this.challengeGroupTechnologies[this.selectedTechnologyIndex];
            if (!challengeGroupTechnology) {
                return "";
            }
            return challengeGroupTechnology;
        },
        selectedTechnologyIndex: function () {
            let selectedIndex = 0;

            this.challengeGroupTechnologies.forEach((technology, index) => {
                if (technology.challengeId === this.selectedChallengeId) {
                    selectedIndex = index;
                }
            });
            return selectedIndex;
        },
    },
    methods: {
        getActiveClass: function (technology) {
            if (technology === this.selectedTechnology) {
                return getLanguageBubbleCSS(this.selectedTechnology);
            }
            return "";
        },
        closeMenu() {
            this.dropDownOpen = false;
        },
        toggleMenu() {
            this.dropDownOpen = !this.dropDownOpen;
        },
        clickHandler(event) {
            // only the clicked element has not a parent dropdown-menu else let it bubble up
            if (!event.target.closest(".dropdown-menu")) {
                this.toggleMenu();
            }
        },
        getLanguageBubbleCSS,
        handleInput(e) {
            this.closeMenu();
            this.selectedChallengeId = e.target.value;
            this.$emit('input', this.selectedChallengeId);
        },
        getTechnologyDisplayNameShort: function (technology) {
            let programmingLanguage = technology.language.toLocaleLowerCase();
            if (programmingLanguage === "") {
                return this.name;
            }
            if (technology.name === "") {
                return LANGUAGES[programmingLanguage];
            }
            return technology.name;
        },
    }
}
</script>
<style scoped>
.dropdown:hover, .dropdown-label:hover {
    cursor: pointer;
}

.dropdown:hover .dropdown-toggle, .dropdown-label:hover .dropdown-toggle {
    transform: scale(1);
}

.dropdown {
    height: 45px;
    padding: 6px;
    background-color: white;
    box-shadow: 0 0 1px 0 rgba(24, 94, 224, 0.15), 0 6px 12px 0 rgba(24, 94, 224, 0.15);
    border-radius: 99px;
    font-size: 1.5rem;
    display: flex;
    align-items: center;
}

.dropdown-label {
    padding-left: 1rem;
    padding-right: 1rem;
    font-family: "Open Sans", sans-serif;
    margin: 0;
    font-weight: normal;
    user-select: none;
}

.dropdown .dropdown-toggle {
    width: 195px;
    transform: scale(0.95);
    display: flex;
    height: 100%;
    align-items: center;
    border-radius: 99px;
}

.dropdown-text {
    width: 100%;
}

.dropdown-menu-item-text {
    padding-left: 0.8rem;
}

.dropdown-menu {
    flex-direction: column;
    border-radius: 10px;
    margin-left: 1rem;
    min-width: 90%;
    display: block;
}

.tab.dropdown-menu-item {
    width: 100%;
    padding: 2rem 0.75rem 2rem;
    justify-content: start;
    display: flex;
    margin: 0;
}

.tab.dropdown-menu-item:hover {
    background-color: #f5f5f5;
    border-radius: 0;
}

.tab.dropdown-menu-item .challenge-state-icon {
    min-width: 1.4rem;
}

input[type="radio"] {
    display: none;
}

.tab {
    display: flex;
    align-items: center;
    justify-content: center;
    width: 150px;
    font-size: 1.5rem;
    font-weight: 500;
    border-collapse: separate;
    cursor: pointer;
    transition: color 0.15s ease-in;
    padding-top: 0.5rem;
    user-select: none;
    -moz-user-select: none;
    -khtml-user-select: none;
    -webkit-user-select: none;
    -o-user-select: none;
    line-height: 2;
    height: 10px;
    letter-spacing: 0.05rem;
    margin-top: 1rem;
}

/* ANIMATION */
.scale-in-ver-top {
    -webkit-animation: scale-in-ver-top 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
    animation: scale-in-ver-top 0.3s cubic-bezier(0.250, 0.460, 0.450, 0.940) both;
}

/* ----------------------------------------------
 * Generated by Animista on 2023-8-18 8:40:50
 * Licensed under FreeBSD License.
 * See http://animista.net/license for more info.
 * w: http://animista.net, t: @cssanimista
 * ---------------------------------------------- */

/**
 * ----------------------------------------
 * animation scale-in-ver-top
 * ----------------------------------------
 */
@-webkit-keyframes scale-in-ver-top {
    0% {
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: 100% 0%;
        transform-origin: 100% 0%;
        opacity: 1;
    }
    100% {
        -webkit-transform: scaleY(1);
        transform: scaleY(1);
        -webkit-transform-origin: 100% 0%;
        transform-origin: 100% 0%;
        opacity: 1;
    }
}

@keyframes scale-in-ver-top {
    0% {
        -webkit-transform: scaleY(0);
        transform: scaleY(0);
        -webkit-transform-origin: 100% 0%;
        transform-origin: 100% 0%;
        opacity: 1;
    }
    100% {
        -webkit-transform: scaleY(1);
        transform: scaleY(1);
        -webkit-transform-origin: 100% 0%;
        transform-origin: 100% 0%;
        opacity: 1;
    }
}


</style>